module.exports = new __parcel__URL__("leaderboard_base_raid_button_inactive.c84e82ac.png").toString();